import { render, staticRenderFns } from "./TestUsers.vue?vue&type=template&id=4a4dd4c4&"
import script from "./TestUsers.vue?vue&type=script&lang=ts&"
export * from "./TestUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports